import { apiClient, ApiName } from '@shared/services/api'

export const fetchPromoCodes = () => {
  return apiClient.get(ApiName.ADMINS, 'super/promoCodes')
}

export const updatePromoCode = (data) => {
  return apiClient.put(ApiName.ADMINS, 'super/promoCodes', data)
}

export const createPromoCode = (data) => {
  return apiClient.post(ApiName.ADMINS, 'super/promoCodes', data)
}

export const deletePromoCode = (id) => {
  return apiClient.delete(ApiName.ADMINS, 'super/promoCodes', id)
}
